module.exports = __webpack_public_path__ + "static/img/buy-active.4044b0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/buy-active.png
// module id = 0VH6
// module chunks = 58